import React, { Suspense } from 'react'
const HelpCenterScreenLazy = React.lazy(() => import('../HelpCenter.screen'))

import type { RouteObject } from 'react-router-dom'
import { LayoutMain } from '../../../layouts/LayoutMain/LayoutMain'
import { AuthRoute } from '../../../routes/routes.components'

export const helpCenterRoutes: RouteObject[] = [
  {
    path: '/help-center',
    element: (
      <AuthRoute>
        <LayoutMain />
      </AuthRoute>
    ),
    children: [
      {
        path: '',
        element: (
          <Suspense fallback={<div></div>}>
            <HelpCenterScreenLazy />
          </Suspense>
        ),
      },
    ],
  },
]
